import List from 'containers/WorkingRegisters/List';
import Edit from '../../containers/WorkingRegisters/Edit';
import Create from '../../containers/WorkingRegisters/Create';
import Show from '../../containers/WorkingRegisters/Show';
import MySchedule from '../../containers/WorkingRegisters/MySchedule';

export default { List, MySchedule, Edit, Create, Show };
